{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Xem tất cả các tùy chọn",
  "Spoiler_Reveal_Tooltip": "Nhấp để hé lộ",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet mục này",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Mục được thu bớt",
  "Spoiler_Reveal_Video_CTA": "Hé lộ video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Mở rộng hình ảnh",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Xem tất cả kết quả",
  "Spoiler_Reveal_Image_Placeholder": "Hình ảnh này có chứa chi tiết tiết lộ trước nội dung",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Tìm kiếm thanh trượt",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Bạn có thể bình chọn cho nhiều câu trả lời.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Hiển thị thêm bộ điều chỉnh âm thanh",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Đóng",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Đang tải {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Hình đại diện người dùng",
  "Preview_ReadMore_Label": "Đọc thêm",
  "Spoiler_Insert_Tooltip": "Chi tiết tiết lộ trước nội dung",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Khối lượng",
  "Spoiler_Reveal_Gallery_Placeholder": "Bộ sưu tập này có chứa chi tiết tiết lộ trước nội dung",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Đặt ngay",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Bật tiếng",
  "Spoiler_Reveal_Gallery_CTA": "Hé lộ bộ sưu tập",
  "Poll_Viewer_ShowLess_CTA": "Ẩn bớt",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Tắt tiếng",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} ẩn danh",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Theo dõi",
  "VerticalEmbed_Products_Button": "Mua ngay",
  "Poll_Viewer_Toast_Error_ServerDown": "Không thể kết nối với máy chủ. Thử lại sau.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} người đã bình chọn cho câu trả lời này",
  "Poll_Viewer_VoteCount": "{{number}} phiếu bình chọn",
  "VerticalEmbed_Events_Button": "Đăng ký ngay",
  "Spoiler_Reveal_Image_CTA": "Hé lộ hình ảnh",
  "Poll_Viewer_Toast_Error_Connection": "Không có mạng. Kiểm tra kết nối của bạn.",
  "Poll_Viewer_Visibility_Owner_Footer": "Chỉ bạn mới có thể nhìn thấy kết quả.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} người đã bình chọn cho câu trả lời này",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Mục được mở rộng",
  "Audio_Plugin_Cover_Alt": "Ảnh bìa âm thanh",
  "Spoiler_Reveal_Video_Placeholder": "Video này có chứa chi tiết tiết lộ trước nội dung",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Xem toàn bộ bài đăng",
  "UploadFile_Viewer_Download": "Tải về {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} giờ",
  "VerticalEmbed_Units_Minute": "{{minutes}} phút",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
